import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PropertyValuesEditor.html?raw';
import lang from 'dojo/_base/lang';
import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import MultiLangEdit from '../../../../moreCore/UI/MultiLangEdit/MultiLangEdit';

class PropertyValuesEditor extends compose(_StatefulSection) {
    templateString: any = template;

    private inputDescription: MdsLax<InstanceType<typeof MultiLangEdit<any>>>;

    isValid(): boolean {
        if (!this.inputDescription.isValid) return false;
        return true;
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);
    }

    onDirtyChange(currentState: boolean) {

    }

    _onChanged(key: string, value: any) {

        this.emit("PropertyValues_ChangedData", { ID: this.entityId, changedData: this.changedData } )
    }

    private _onChange_ValuesAttributes(key: string, newValue: number | string, oldValue: string) {

        if (newValue) {
            switch (key) {
                case "value_double":
                    this.setAttributeValue("value_text", null)
                    break;
                case "value_text":
                    this.setAttributeValue("value_double", null)
                    break;
            }
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.addOnchanged("value_double", lang.hitch(this, this._onChange_ValuesAttributes))
        this.addOnchanged("value_text", lang.hitch(this, this._onChange_ValuesAttributes))
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PropertyValuesEditor);
